import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAnalyticsStore, type AnalyticsTab } from '@/store/analytics.store';

const VALID_TABS: AnalyticsTab[] = [
  'training-intelligence',
  'running',
  'fitness',
  'performance',
  'body',
];

export const useUrlSyncedAnalyticsTab = () => {
  const activeTab = useAnalyticsStore((s) => s.activeTab);
  const setActiveTab = useAnalyticsStore((s) => s.setActiveTab);
  const [searchParams, setSearchParams] = useSearchParams();
  const syncingRef = React.useRef(false);

  // Initialize from URL on mount
  React.useEffect(() => {
    const tab = searchParams.get('tab') as AnalyticsTab | null;
    if (tab && VALID_TABS.includes(tab) && tab !== activeTab) {
      syncingRef.current = true;
      setActiveTab(tab);
      syncingRef.current = false;
    } else if (!tab) {
      // Ensure URL has the current tab
      setSearchParams({ tab: activeTab }, { replace: true } as any);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Keep URL in sync when state changes
  React.useEffect(() => {
    if (syncingRef.current) return;
    const current = searchParams.get('tab');
    if (current !== activeTab) {
      const params = new URLSearchParams(searchParams);
      params.set('tab', activeTab);
      setSearchParams(params, { replace: true } as any);
    }
  }, [activeTab, searchParams, setSearchParams]);

  return { activeTab, setActiveTab };
};
